class InstrumentDetails {
    constructor(props) {
        const {
            instrumentId,
            tickerSymbol,
            name,
            closeValue,
            changeValue,
            changePercentage,
            marketGroup,
            type,
        } = props;

        this.instrumentId = instrumentId;
        this.tickerSymbol = tickerSymbol;
        this.name = name;
        this.changePercentage = changePercentage;
        this.closeValue = {
            amount: closeValue?.amount,
            currency: closeValue?.currency,
        };
        this.changeValue = {
            amount: changeValue?.amount,
            currency: changeValue?.currency,
        };
        this.marketGroup = marketGroup;
        this.type = type;
    }
}

export default InstrumentDetails;
